import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Layers, Loader2 } from "lucide-react";

export default function BulkQueueDialog({ grade, subject, onDone }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const links = text.split(/\s+/).filter((l) => l.startsWith("http"));
  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post("/materials/bulk", { grade, subject, links });
      toast.success(`Queued ${r.data.queued} recordings`);
      setText(""); setOpen(false); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not queue"); } finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid="bulk-queue-open" onClick={() => setOpen(true)} className="w-full inline-flex items-center justify-center gap-2 text-sm font-semibold text-slate-300 border border-dashed border-[#334155] rounded-full px-4 py-2.5 hover:border-indigo-400/60 hover:text-indigo-200 transition-colors">
        <Layers className="w-4 h-4" /> Bulk queue many links
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#111726] border-[#1E293B] text-slate-100 max-w-xl" data-testid="bulk-queue-dialog">
          <DialogHeader><DialogTitle className="font-display">Bulk queue · {grade} · {subject}</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-400">Paste Google Drive links, one per line. Titles come from the Drive file names. Each one is queued and processed when Gemini is free.</p>
          <textarea data-testid="bulk-queue-input" value={text} onChange={(e) => setText(e.target.value)} rows={8} placeholder={"https://drive.google.com/file/d/…\nhttps://drive.google.com/file/d/…"}
            className="w-full bg-[#090D16] border border-[#1E293B] rounded-xl px-4 py-3 text-sm font-mono text-slate-100 outline-none focus:border-indigo-400 resize-none" />
          <div className="flex items-center justify-between">
            <span className="text-xs text-slate-500" data-testid="bulk-queue-count">{links.length} link{links.length === 1 ? "" : "s"} found (max 30)</span>
            <button data-testid="bulk-queue-submit" onClick={submit} disabled={busy || !links.length} className="inline-flex items-center gap-2 bg-indigo-500 text-white font-bold rounded-full px-5 py-2.5 text-sm hover:bg-indigo-400 disabled:opacity-50 transition-colors">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Layers className="w-4 h-4" />} Queue all
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
